import { render } from "./UiArticleIndex.vue?vue&type=template&id=33692dd7&scoped=true"
import script from "./UiArticleIndex.vue?vue&type=script&lang=js"
export * from "./UiArticleIndex.vue?vue&type=script&lang=js"

import "./UiArticleIndex.vue?vue&type=style&index=0&id=33692dd7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33692dd7"

export default script